import React, { useEffect, useState } from "react";
import Select from "react-select";
import { SeasonPassFieldLabel } from "../../SeasonPass/SeasonPassFieldLabel";
import { SelectedTickets } from "../SelectedTickets";

import { paymentMethodOptions as defaultOptions } from "../../SeasonPass/constants";
import { isValidEmail } from "../../../helpers/validators";

import "../OpenSell.sass";
import { getCurrentLanguageTexts } from "../../../constants/seasonPassPersonalInfoLangs";

export const ChoosePaymentMethod = ({
  tickets,
  setCouponHandler,
  coupon,
  total,
  buyerEmail,
  handleRepaetEmailChange,
  reapetedBuyerEmail,
  email,
  hasSeats,
  totalFee,
  currency,
  paymentMethod,
  paymentMethodOptions = defaultOptions,
  handleChange = () => { },
  allowEnterCouponCode = true,
  theme = null,
  onObjectDeselected
}) => {

  const txt = getCurrentLanguageTexts();

  const isEmailsNoMatch =
    reapetedBuyerEmail && reapetedBuyerEmail !== buyerEmail;

  const [inputReapetedEmail, setInputReapetedEmail] = useState("");
  const [validEmail, setValidEmail] = useState(true);
  const [focusedElement, setFocusedElement] = useState(null);
  const [isBtnHover, setBtnHover] = useState(false);

  const changeInputEmailHandler = (value) => {
    setInputReapetedEmail(value.trim());
  };

  const handleClick = () => {
    handleChange("buyerEmail", reapetedBuyerEmail);
  };

  const handleMouseEnter = (e) => {
    if (theme && focusedElement !== e.target.name) {
      e.target.style.borderColor = theme.primarySemiLightColor;
    }
  };
  const handleMouseLeave = (e) => {
    if (theme && focusedElement !== e.target.name) {
      e.target.style.borderColor = '#f1f1f1';
    }
  };
  const handleFocusElement = (e) => {
    if (theme) {
      e.target.style.borderColor = theme.primaryColor;
      setFocusedElement(e.target.name);
    }
  }
  const handleBlureElement = (e) => {
    if (theme) {
      e.target.style.borderColor = '#f1f1f1';
    }
    setFocusedElement(null);
  };

  useEffect(() => {
    setValidEmail(
      isValidEmail(inputReapetedEmail) || inputReapetedEmail === ""
    );
  }, [inputReapetedEmail]);

  const themeSelectStyle = theme ? {
    control: (baseStyles, state) => ({
      ...baseStyles,
      boxShadow: "none",
      borderColor: state.isFocused ? theme.primaryColor : '#f1f1f1',
      "&:hover": {
        borderColor: state.isFocused ? theme.primaryColor : theme.primarySemiLightColor,
      },
    }),
    option: (styles, state) => ({
      ...styles,
      backgroundColor: state.isSelected ? theme.primaryColor : state.isFocused ? theme.primarySemiLightColor : "",
      "&:hover": {
        backgroundColor: state.isFocused ? theme.primarySemiLightColor : "",
      },
    })
  } : {};

  const handleMouseEnterOnBtn = () => {
    setBtnHover(true);
  };
  const handleMouseLeaveBtn = () => {
    setBtnHover(false);
  };

  const btnStyle = {
    backgroundColor: `${theme ? theme.primaryColor : ''}`,
    boxShadow: `${theme && isBtnHover ? `0px 0px 8px 0px ${theme.primaryColor}` : ''}`,
    margin: "10px 0"
  }

  return (
    <div className="partizan-open-selling__step">
      <div className="partizan-open-selling__step-hero">
        <h4 className="partizan-open-selling__text-bold">{txt.choosePaymentMethodTxt["Ticket receipt"]}</h4>
        <p
          style={{ marginBottom: "20px" }}
          className="partizan-open-selling__text-normal-small"
        >
          {txt.choosePaymentMethodTxt["You will receive tickets at"]}{" "}
          <span className="partizan-open-selling__text-bold-small">
            {email}
          </span>
        </p>

        <SeasonPassFieldLabel
          shouldWrapInLabel={false}
          label={txt.choosePaymentMethodTxt["Please repeat your email address"]}
          isRequired={!reapetedBuyerEmail}
        >
          <div
            style={{ marginBottom: "10px" }}
            className="partizan-open-selling__validation-fields-group"
          >
            <div className="block-input-validation">
              <input
                className="input-field-validation"
                placeholder={txt.choosePaymentMethodTxt["Enter your email"]}
                value={inputReapetedEmail}
                onChange={(e) => {
                  handleRepaetEmailChange(e.target.value);
                  changeInputEmailHandler(e.target.value);
                }}
                onMouseEnter={handleMouseEnter}
                onFocus={handleFocusElement}
                onMouseLeave={handleMouseLeave}
                onBlur={handleBlureElement}
                type="text"
              />
              {!validEmail && (
                <span className="input-valid-error">
                  {txt.choosePaymentMethodTxt["This is an invalid email"]}
                </span>
              )}
            </div>

            {isEmailsNoMatch && validEmail && (
              <button onClick={handleClick}
                className="btn-primary"
                onMouseEnter={handleMouseEnterOnBtn}
                onMouseLeave={handleMouseLeaveBtn}
                style={btnStyle}
              >
                {txt.choosePaymentMethodTxt["Use this email"]}
              </button>
            )}
          </div>

          {isEmailsNoMatch && (
            <span className="partizan-open-selling__text-normal-small partizan-open-selling__text-error">
              {txt.choosePaymentMethodTxt["Email Error"]}
            </span>
          )}
        </SeasonPassFieldLabel>

        <SeasonPassFieldLabel
          label={txt.choosePaymentMethodTxt["Payment method"]}
          isRequired={!paymentMethod}
          className="partizan-open-selling__payment-method"
        >
          <Select
            options={paymentMethodOptions}
            name="paymentMethod"
            value={paymentMethodOptions.find(
              ({ value }) => paymentMethod.id === value.id
            )}
            onChange={(value) => handleChange("paymentMethod", value)}
            classNamePrefix={theme ? "theme-select" : "custom-select"}
            className="partizan-open-selling__select"
            styles={themeSelectStyle}
          />
        </SeasonPassFieldLabel>
      </div>
      <div className="partizan-open-selling__step-info">
        <SelectedTickets
          tickets={tickets}
          hasSeats={hasSeats}
          currency={currency}
          total={total}
          totalFee={totalFee}
          setCouponHandler={setCouponHandler}
          coupon={coupon}
          allowEnterCouponCode={allowEnterCouponCode}
          isTermsCheckbox={false}
          onObjectDeselected={onObjectDeselected}
        />
      </div>
    </div>
  );
};
